import StockRow from './StockRow';
import { useSort } from '../../hooks/useSort';

const StockTable = ({ stocks, ...props }) => {

  const {
    sortedData,
    requestSort,
    getSortIndicator
  } = useSort(stocks);

  return (
    <table className="stock-table">
      <thead>
        <tr>
          <th onClick={() => requestSort('name')}>Company {getSortIndicator('name')}</th>
          <th onClick={() => requestSort('price')}>Price {getSortIndicator('price')}</th>
          <th onClick={() => requestSort('objective')}>Objective {getSortIndicator('objective')}</th>
          <th onClick={() => requestSort('ratio')}>Ratio {getSortIndicator('ratio')}</th>
          <th onClick={() => requestSort('daily_change')}>Daily Change {getSortIndicator('daily_change')}</th>
          <th onClick={() => requestSort('five_days_change')}>5 Days Change {getSortIndicator('five_days_change')}</th>
          <th onClick={() => requestSort('Local_Max_Count_2Y_opt')}>Nb Peaks {getSortIndicator('Local_Max_Count_2Y_opt')}</th>
          <th onClick={() => requestSort('Local_Min_Count_2Y_opt')}>Nb Valleys {getSortIndicator('Local_Min_Count_2Y_opt')}</th>
          <th>Time</th>
          <th>Watchlist</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((stock) => (
            <StockRow key={stock.url} stock={stock} {...props} />
        ))}
      </tbody>
    </table>
  );
};

export default StockTable;